import { Component, ContentChild, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { BillingPeriod, Plan, PlanTypes } from "@asset-owner-portal/api/plan";
import { DeloitteAiCardActionDirective } from "./card-action";
import { PlanToStateService } from "./services/plan-to-state.service";

@Component({
    selector: "deloitteai-plan-card",
    templateUrl: "./plan-card.html",
    styleUrls: ["./plan-card.scss"]
})
export class DeloitteAiPlanCardComponent implements OnInit {
    public plan_types = PlanTypes;
    public current_plan_type = undefined;
    public multi_tier = false;
    public table_data: any[] = [];
    public table_data_recurring: any[] = [];
    public billing_period: BillingPeriod;

    @Input() formGroup: FormGroup;

    @Input() public preview = false;

    @Input()
    public plan: Plan;

    @Input()
    public buttonLabel = "Select";

    @Input()
    public disabled = false;

    @ContentChild(DeloitteAiCardActionDirective)
    public actionTrigger: DeloitteAiCardActionDirective;

    @Output()
    public activate: EventEmitter<Plan> = new EventEmitter();

    constructor(public planToStateService: PlanToStateService) { }

    ngOnInit(): void {
        if (!this.plan.state) {
            this.previewFromPlan();
        } else {
            this.previewFromState();
        }
    }

    handleClick($event: MouseEvent): void {
        $event.stopPropagation();
        $event.preventDefault();
        /*
        sessionStorage.setItem("plan", JSON.stringify(this.payment));
        this.router.navigate(["/" + url]);
        */
        this.activate.emit(this.plan);
    }

    private previewFromState(): void {
        this.current_plan_type = this.plan.state?.q1;
        this.multi_tier = this.plan.state.q5?.multi_tier;
        if (this.current_plan_type === this.plan_types.TIME_BOUND) {
            this.table_data = this.plan.state.q2;
        } else {
            if (this.plan.state.q5?.plan_components) {
                if (this.current_plan_type === this.plan_types.MEASURABLE) {
                    this.table_data = this.groupBy(this.plan.state.q5.plan_components, 'tier');
                } else {
                    const nonRecurringPlanComponents = this.plan.state.q5.plan_components?.filter(item => !item.isRecurring);
                    this.table_data = this.groupBy(nonRecurringPlanComponents, 'tier');
                    this.table_data_recurring = this.plan.state.q5?.plan_components?.filter(item => item.isRecurring);
                }
                this.billing_period = BillingPeriod[this.plan.state.q5.billing_period];
            }
        }

        if (!this.preview) {
            delete this.plan.state;
        }
    }

    private previewFromPlan(): void {
        if (this.plan.phases?.length > 0) {
            this.plan = this.planToStateService.buildStateFromPlan(this.plan);
            this.previewFromState();
        }
    }

    private groupBy(arr: any, prop: string) {
        const map = new Map(Array.from(arr, obj => [obj[prop], []]));
        arr.forEach(obj => map.get(obj[prop]).push(obj));
        return Array.from(map.values());
    }
}
